import startCase from 'lodash/startCase'

export const LANDING_PAGES_API_IDENTIFIER = 'content_page'
export const DEFAULT_ERROR_MESSAGE = 'Whoops, there was a problem...'
export const POLL_INTERVAL_MS = 30 * 1000
export const TWENTY_FOUR_H_MS = 24 * 60 * 60 * 1000

export const LANDING_PAGES_IMPORT_MANAGEMENT_OPTIONS = [
    {
        value: LANDING_PAGES_API_IDENTIFIER,
        selectLabel: 'Bulk Manage Landing Pages',
        listTitle: 'Bulk Manage Landing Pages',
        historyTitle: 'Bulk Manage Landing Pages History',
        noResultsMessage:
            'No landing page imports yet. Upload a CSV containing the landing page data to manage.',
        uploadSuccessMessage: 'Landing pages import queued successfully.',
        instructionsBeforeGuide:
            'Upload a CSV to bulk update landing pages. Generate a Landing Pages Export to get your base file, edit the values, then upload it here. See the ',
        guideLinkLabel: 'landing pages import guide',
        instructionsAfterGuide:
            ' for guidance. Use Download CSV to retrieve the uploaded file for each import.',
        exampleCsv: null,
    },
]

export const getLandingPagesImportManagementOption = (value) =>
    LANDING_PAGES_IMPORT_MANAGEMENT_OPTIONS.find((o) => o.value === value) ??
    LANDING_PAGES_IMPORT_MANAGEMENT_OPTIONS[0]

export function exampleCsvDataHref(csvText) {
    return 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvText)
}

export const importLogId = (row) => row?.originId ?? row?.id

export const formatLandingPagesDataTypeLabel = (value) => {
    if (value === LANDING_PAGES_API_IDENTIFIER) return 'Landing Pages'
    return startCase((value || '').replaceAll('_', ' '))
}

export const isCreatedWithinLast24Hours = (createdAt) => {
    if (!createdAt) return false
    const t = new Date(createdAt).getTime()
    if (Number.isNaN(t)) return false
    return t >= Date.now() - TWENTY_FOUR_H_MS
}

export function axiosHydraMessage(err) {
    const d = err?.response?.data
    if (!d) return null
    if (Object.prototype.hasOwnProperty.call(d, 'hydra:description')) {
        return d['hydra:description']
    }
    if (Array.isArray(d.violations) && d.violations.length > 0) {
        return d.violations
            .map((v) => v.message)
            .filter(Boolean)
            .join(' ')
    }
    return null
}